import type {
  HubDatapoolExampleStream,
  HubExampleStream,
} from '@robovision/hub'
import { i18n } from '~i18n'


interface EmulatorCameraParams {
  config: HubDatapoolExampleStream
  createdAt: string
  datapoolId?: string
  id: string
  name?: string
  projectId: string
  simulatedFps: number
  tagId?: string
  valid: boolean
}

export class DatapoolExampleStream {
  static readonly modelName = 'DatapoolExampleStream'

  public id: string
  public config: HubDatapoolExampleStream
  public datapoolId?: string
  public name?: string
  public projectId: string
  public simulatedFps: number
  public tagId?: string
  public valid: boolean
  public createdAt: string

  constructor (params: EmulatorCameraParams) {
    this.id = params.id
    this.config = params.config
    this.datapoolId = params.datapoolId
    this.name = params.name
    this.projectId = params.projectId
    this.simulatedFps = params.simulatedFps
    this.tagId = params.tagId
    this.valid = params.valid
    this.createdAt = params.createdAt
  }

  public get activityLabel (): string {
    if (!this.valid) {
      return i18n.t('cameras.titles.invalid')
    } else {
      return i18n.t('cameras.titles.valid')
    }
  }

  public get cameraTypeLabel (): string {
    return i18n.t('cameras.types.emulator')
  }

  public static fromResponse (data: HubExampleStream): DatapoolExampleStream {
    const {
      datapoolId,
      sampleFilters,
      simulatedFps,
    } = data.config as HubDatapoolExampleStream

    return new DatapoolExampleStream({
      config: data.config as HubDatapoolExampleStream,
      createdAt: data.createdAt,
      datapoolId,
      id: data.id,
      name: data.name,
      projectId: data.projectId,
      simulatedFps,
      tagId: sampleFilters?.[0]?.tagIds?.[0]?.[0],
      valid: data.valid,
    })
  }
}
